import React, { useEffect, useState, useContext, useMemo } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import {
  Card,
  CardHeader,
  Checkbox,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Grid,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl
} from '@mui/material';
import { menuAPI } from 'api/api';
import axiosInstance from 'interceptors/axiosInstance';
import Notification from 'ui-component/notification/notification';
import Spinnerprogress from 'ui-component/circular-progress/Spinnerprogress';
import { updateActiveArchivedDetails } from 'api/api';
import { AppContext } from 'App';
import EastIcon from '@mui/icons-material/East';
import WestIcon from '@mui/icons-material/West';

function not(a, b) {
  return a.filter((value) => !b.includes(value));
}

function intersection(a, b) {
  return a.filter((value) => b.includes(value));
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

const ConfigComponent = () => {
  const [client, setClient] = useState(null);
  const [clientMenu, setClientMenu] = useState([]);
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const [openNotification, setOpenNotification] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  // for refresh menu
  const { setMenuValue } = useContext(AppContext);
  const [setRefreshMenus] = setMenuValue;

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      await axiosInstance
        .get(menuAPI)
        .then((response) => {
          setClientMenu(response.data);
        })
        .catch((error) => console.log(error));
    };
    fetchData();
    setIsLoading(false);
  }, []);

  const handleChange = (event) => {
    setIsLoading(true);
    setClient(event.target.value);
    const selectedClient = clientMenu.find((item) => item.Key === event.target.value);
    const updatedLeft = selectedClient?.Items?.filter((item) => parseInt(item.IsActive) === 1) || [];
    const updatedRight = selectedClient?.Items?.filter((item) => parseInt(item.IsActive) === 0) || [];
    setLeft(updatedLeft);
    setRight(updatedRight);
    setIsLoading(false);
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
    setIsChanged(true);
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
    setIsChanged(true);
  };

  // Save function to update the active and archived lists
  const handleSave = async () => {
    const activeList = left.map((items) => items.Key);
    const archivedList = right.map((items) => items.Key);
    if (client) {
      await axiosInstance
        .post(updateActiveArchivedDetails, {
          ClientId: client,
          ActiveList: activeList,
          ArchivedList: archivedList
        })
        .then((response) => {
          if (response.status === 200) {
            setOpenNotification(true);
            setIsChanged(false);
            setRefreshMenus((refreshMenus) => refreshMenus + 1);
          }
        });
    }
  };

  const disableSaveBtn = useMemo(() => {
    if (client !== null && client !== undefined && isChanged) {
      return false;
    }
    return true;
  },[client, isChanged]);

  const customList = (title, items) => (
    <Card sx={{ backgroundColor: '#ede7f6', border: '2px solid #ede7f6' }}>
      <CardHeader
        sx={{ px: 2, py: 1 }}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={numberOfChecked(items) === items.length && items.length !== 0}
            indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
            disabled={items.length === 0}
            inputProps={{
              'aria-label': 'all items selected'
            }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} selected`}
      />
      <Divider />
      <List
        sx={{
          width: 350,
          height: 350,
          bgcolor: 'background.paper',
          overflow: 'auto'
        }}
        dense
        component="div"
        role="list"
      >
        {items.map((value, index) => {
          const labelId = `transfer-list-all-item-${value}-label`;

          return (
            <ListItemButton key={value.Key ?? 'Key' + index} role="listitem" onClick={handleToggle(value)}>
              <ListItemIcon>
                <Checkbox
                  checked={checked.includes(value)}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    'aria-labelledby': labelId
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value.Text} />
            </ListItemButton>
          );
        })}
      </List>
    </Card>
  );

  return (
    <MainCard>
      {isLoading ? (
        <Spinnerprogress />
      ) : (
        <>
          <FormControl disabled={false} variant="filled" sx={{ m: 1, minWidth: 260 }} error={false}>
            <InputLabel id="instance-type-label">Select Client</InputLabel>
            <Select labelId="select-client" id="select-client" name="select-client" value={client} onChange={handleChange}>
              {clientMenu.map((item, index) => {
                return (
                  <MenuItem key={index + item.Text} value={item.Key}>
                    {item.Text}
                  </MenuItem>
                );
              })}
            </Select>
            {/* {error.InstanceTypeValue && <FormHelperText>Please select valid Instance Type</FormHelperText>} */}
          </FormControl>
          <Notification openNotification={openNotification} setOpenNotification={setOpenNotification} message={'Saved Successfully'} />
          <Grid container spacing={2} sx={{ justifyContent: 'center', alignItems: 'center', mt: 3 }}>
            <Grid>{customList('Active', left)}</Grid>
            <Grid>
              <Grid container direction="column" sx={{ alignItems: 'center' }}>
                <Button
                  sx={{ my: 0.5, ml: 1, mr: 1 }}
                  variant="outlined"
                  size="1.3rem"
                  onClick={handleCheckedRight}
                  disabled={leftChecked.length === 0}
                  aria-label="move selected right"
                  color="secondary"
                >
                  <EastIcon />
                </Button>
                <Button
                  sx={{ my: 0.5, ml: 1, mr: 1 }}
                  variant="outlined"
                  size="1.3rem"
                  onClick={handleCheckedLeft}
                  disabled={rightChecked.length === 0}
                  aria-label="move selected left"
                  color="secondary"
                >
                  <WestIcon />
                </Button>
              </Grid>
            </Grid>
            <Grid>{customList('Archived', right)}</Grid>
          </Grid>
          <Button size="1.3rem" type="button" variant="contained" color="secondary" sx={{ marginTop: '20px' }} onClick={handleSave} disabled={disableSaveBtn}>
            Save
          </Button>
        </>
      )}
    </MainCard>
  );
};

export default ConfigComponent;
